import {createAsyncThunk} from '@reduxjs/toolkit';
import {preferencesService} from '../../services/preferences.service';
import {type} from './state';
import {createClearAllAsyncThunk, createClearErrorAsyncThunk} from "../shared-actions";

export const getCommunicationPreferences = createAsyncThunk(
    `${type}/getCommunicationPreferences`,
    async (customerId: number, {rejectWithValue}) => {
        try {
            return await preferencesService.getCommunicationPreferences(customerId);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateCommunicationPreferences = createAsyncThunk(
    `${type}/updateCommunicationPreferences`,
    async (payload: { customerId: number; data: { marketing_email_status: number; marketing_email_reason?: string; push_notifications_status?: number } }, {rejectWithValue}) => {
        try {
            return await preferencesService.updateCommunicationPreferences(payload.customerId, payload.data);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const clearErrorsAction = createClearErrorAsyncThunk(type);
export const clearAllAction = createClearAllAsyncThunk(type);
